import { render, staticRenderFns } from "./OrganizeTableForm.vue?vue&type=template&id=ac3a5df2&scoped=true"
import script from "./OrganizeTableForm.vue?vue&type=script&lang=js"
export * from "./OrganizeTableForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizeTableForm.vue?vue&type=style&index=0&id=ac3a5df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3a5df2",
  null
  
)

export default component.exports